import { render } from "./WhatsAppBroadcastView.vue?vue&type=template&id=547313cc&scoped=true"
import script from "./WhatsAppBroadcastView.vue?vue&type=script&lang=js"
export * from "./WhatsAppBroadcastView.vue?vue&type=script&lang=js"

import "./WhatsAppBroadcastView.vue?vue&type=style&index=0&id=547313cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547313cc"]])

export default __exports__